import { useUpdateCompanyRevenueMutation } from "@/pages/Private/redux/company-revenue/company-revenue.api";

import { CompanyRevenue, CompanyRevenueSchema } from "../../schema/company-revenue";
import EditModeCompanyRevenueItem from "./EditableCompanyRevenueItem";
import ViewModeCompanyRevenueItem from "./ViewCompanyRevenueItem";

interface EditableCompanyRevenueItemProps {
	data: CompanyRevenue;
	isEditing: boolean;
	isEditingInProcess: boolean;
	setEditing: (value: number) => void;
	setDeletingCompanyRevenue: (value: CompanyRevenue | null) => void;
}

export default function EditableCompanyRevenueItem({
	data,
	isEditing,
	setEditing,
	setDeletingCompanyRevenue,
	isEditingInProcess,
}: EditableCompanyRevenueItemProps) {
	const [updateCompanyRevenue, { isLoading }] = useUpdateCompanyRevenueMutation();

	const handleUpdateCompanyRevenue = async (values: CompanyRevenue) => {
		try {
			await updateCompanyRevenue(values).unwrap();
		} catch (error) {
			console.error("An unexpected error occurred:", error);
		}
	};

	return isEditing ? (
		<EditModeCompanyRevenueItem
			data={data}
			isLoading={isLoading}
			setEditing={setEditing}
			validationSchema={CompanyRevenueSchema}
			onSubmit={handleUpdateCompanyRevenue}
		/>
	) : (
		<ViewModeCompanyRevenueItem
			data={data}
			isEditingInProcess={isEditingInProcess}
			isLoading={false}
			setDeletingCompanyRevenue={setDeletingCompanyRevenue}
			setIsEditing={setEditing}
		/>
	);
}
